import React from 'react';
import { motion } from 'framer-motion';

const ScannerRadar = () => {
  return (
    <div className="relative w-16 h-16 rounded-full border border-transit-neon/30 bg-asphalt-800/50 overflow-hidden flex items-center justify-center">
      {/* Grid lines */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#00E5FF1A_1px,transparent_1px),linear-gradient(to_bottom,#00E5FF1A_1px,transparent_1px)] bg-[size:4px_4px]" />
      
      {/* Crosshair */}
      <div className="absolute w-full h-[1px] bg-transit-neon/40" />
      <div className="absolute h-full w-[1px] bg-transit-neon/40" />
      
      {/* Radar Sweep */}
      <motion.div 
        className="absolute w-1/2 h-1/2 origin-bottom-right bg-gradient-to-tr from-transparent via-transit-neon/20 to-transit-neon/60 border-r border-transit-neon"
        style={{ top: 0, left: 0 }}
        animate={{ rotate: 360 }}
        transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
      />
      
      {/* Blips */}
      <motion.div 
        className="absolute w-1.5 h-1.5 rounded-full bg-amber-500 shadow-[0_0_5px_#FFB300]"
        style={{ top: '25%', left: '60%' }}
        animate={{ opacity: [0, 1, 0] }}
        transition={{ duration: 2, repeat: Infinity, times: [0, 0.1, 1], delay: 0.5 }}
      />
      <motion.div 
        className="absolute w-1 h-1 rounded-full bg-transit-neon shadow-[0_0_5px_#00E5FF]"
        style={{ top: '70%', left: '30%' }}
        animate={{ opacity: [0, 1, 0] }}
        transition={{ duration: 3, repeat: Infinity, times: [0, 0.1, 1], delay: 1.2 }}
      />
    </div>
  );
};

export default ScannerRadar;